/*
================================================================ 
		 Copyright (c) 2018-2020 Digitize Things Inc.           
					 All rights reserved.                       
================================================================ 
*/

export default (
  componentList,
  solutions,
  accessories,
  tenantId,
  totalRCDiscount,
  totalNRDiscount,
) => {
  let nowTotal = 0;
  let recTotal = 0;

  let discount = 0;
  let totalDiscount = 0;
  let nowDiscountedPrice = 0;
  let recDiscountedPrice = 0;

  let tempNowDiscountedPrice = 0;
  let tempRecDiscountedPrice = 0;

  for (let i = 0; i < solutions.length; i++) {
    let rec = 0;
    let now = 0;
    let recCustom = 0;
    let nowCustom = 0;

    if (tenantId) {
      if (solutions[i].tenantId === tenantId) {
        discount = solutions[i].discount;
        totalDiscount += solutions[i].discount ? solutions[i].discount : 0;
        if (solutions[i].solution) {
          rec += solutions[i].solution.price.recurringPrice
            ? solutions[i].solution.price.recurringPrice.price
            : 0;
          now += solutions[i].solution.price.recurringPrice
            ? 0
            : solutions[i].solution.price.purchasePrice;
        }
        // {
        // componentList.length > 0 && componentList.map((component) =>
        //     solutions[i][component.name] && solutions[i][component.name].length > 0 && solutions[i][component.name].map((componentType) =>
        //         componentType.quantity && componentType.quantity > 0 ?
        //             (
        //                 recCustom += componentType.price.recurringPrice ? componentType.price.recurringPrice.price * componentType.quantity : 0,
        //                 nowCustom += componentType.price.recurringPrice ? 0 : componentType.price.purchasePrice * componentType.quantity
        //             )
        //             :
        //             (
        //                 rec += componentType.price.recurringPrice ? componentType.price.recurringPrice.price : 0,
        //                 now += componentType.price.recurringPrice ? 0 : componentType.price.purchasePrice
        //             )
        //     )
        // )
        // }

        solutions[i].associatedItems &&
          solutions[i].associatedItems.length > 0 &&
          solutions[i].associatedItems.map((component) => {
            if (component.customerViewable) {
              if (component.quantity && component.quantity > 0) {
                if (component.recurringCost || component.nonRecurringCost) {
                  recCustom += component.recurringCost;
                  nowCustom += component.nonRecurringCost;
                  if (component.depositPrice) {
                    nowCustom += +component.depositPrice;
                  }
                  if (component.usageCharge) {
                    nowCustom += +component.usageCharge;
                  }
                  if (component.setupFee) {
                    nowCustom += +component.setupFee;
                  }
                } else {
                  recCustom += component.price.recurringPrice
                    ? +component.price.recurringPrice.price * component.quantity
                    : 0;
                  nowCustom += component.price.recurringPrice
                    ? 0
                    : +component.price.purchasePrice * component.quantity;
                  if (
                    component.otherPrices &&
                    component.otherPrices.length > 0
                  ) {
                    for (var i = 0; i < component.otherPrices.length; i++) {
                      nowCustom += +component.otherPrices[i].price;
                    }
                  }
                }
              } else {
                if (component.recurringCost || component.nonRecurringCost) {
                  rec += component.recurringCost;
                  now += component.nonRecurringCost;
                  if (component.depositPrice) {
                    now += +component.depositPrice;
                  }
                  if (component.usageCharge) {
                    now += +component.usageCharge;
                  }
                  if (component.setupFee) {
                    now += +component.setupFee;
                  }
                } else {
                  rec += component.price.recurringPrice
                    ? +component.price.recurringPrice.price
                    : 0;
                  now += component.price.recurringPrice
                    ? 0
                    : +component.price.purchasePrice;
                  if (
                    component.otherPrices &&
                    component.otherPrices.length > 0
                  ) {
                    for (var i = 0; i < component.otherPrices.length; i++) {
                      now += +component.otherPrices[i].price;
                    }
                  }
                }
              }
            }
          });
        // solutions[i].associatedItems.map((component) =>
        // 	component.customerViewable &&
        // 	(component.quantity && component.quantity > 0
        // 		? ((recCustom += component.price.recurringPrice ? +component.price.recurringPrice.price * component.quantity : 0),
        // 			(nowCustom += component.price.recurringPrice ? 0 : +component.price.purchasePrice * component.quantity))
        // 		: ((rec += component.price.recurringPrice ? +component.price.recurringPrice.price : 0),
        // 			(now += component.price.recurringPrice ? 0 : +component.price.purchasePrice)))
        // );

        recTotal += rec * solutions[i].quantity;
        nowTotal += now * solutions[i].quantity;
        recTotal += recCustom * solutions[i].quantity;
        nowTotal += nowCustom * solutions[i].quantity;

        let recItemPrice = rec * solutions[i].quantity;
        let nowItemPrice = now * solutions[i].quantity;

        let recItemPriceCustom = recCustom * solutions[i].quantity;
        let nowItemPriceCustom = nowCustom * solutions[i].quantity;

        tempRecDiscountedPrice +=
          recItemPrice - recItemPrice * (discount / 100);
        tempNowDiscountedPrice +=
          nowItemPrice - nowItemPrice * (discount / 100);

        tempRecDiscountedPrice +=
          recItemPriceCustom - recItemPriceCustom * (discount / 100);
        tempNowDiscountedPrice +=
          nowItemPriceCustom - nowItemPriceCustom * (discount / 100);
      }
    } else {
      if (solutions[i].solution) {
        rec += solutions[i].solution.price.recurringPrice
          ? solutions[i].solution.price.recurringPrice.price
          : 0;
        now += solutions[i].solution.price.recurringPrice
          ? 0
          : solutions[i].solution.price.purchasePrice;
      }
      // {
      // 	componentList.length > 0 &&
      // 		componentList.map(
      // 			(component) =>
      // 				solutions[i][component.name] &&
      // 				solutions[i][component.name].length > 0 &&
      // 				solutions[i][component.name].map((componentType) =>
      // 					componentType.quantity && componentType.quantity > 0
      // 						? ((recCustom += componentType.price.recurringPrice ? componentType.price.recurringPrice.price * componentType.quantity : 0),
      // 							(nowCustom += componentType.price.recurringPrice ? 0 : componentType.price.purchasePrice * componentType.quantity))
      // 						: ((rec += componentType.price.recurringPrice ? componentType.price.recurringPrice.price : 0),
      // 							(now += componentType.price.recurringPrice ? 0 : componentType.price.purchasePrice))
      // 				)
      // 		);
      // }

      solutions[i].associatedItems &&
        solutions[i].associatedItems.length > 0 &&
        solutions[i].associatedItems.map((component) => {
          if (component.customerViewable) {
            if (component.quantity && component.quantity > 0) {
              if (component.recurringCost || component.nonRecurringCost) {
                recCustom += component.recurringCost;
                nowCustom += component.nonRecurringCost;
                if (component.depositPrice) {
                  nowCustom += +component.depositPrice;
                }
                if (component.usageCharge) {
                  nowCustom += +component.usageCharge;
                }
                if (component.setupFee) {
                  nowCustom += +component.setupFee;
                }
              } else {
                recCustom += component.price.recurringPrice
                  ? +component.price.recurringPrice.price * component.quantity
                  : 0;
                nowCustom += component.price.recurringPrice
                  ? 0
                  : +component.price.purchasePrice * component.quantity;
                if (component.otherPrices && component.otherPrices.length > 0) {
                  for (var i = 0; i < component.otherPrices.length; i++) {
                    nowCustom += +component.otherPrices[i].price;
                  }
                }
              }
            } else {
              if (component.recurringCost || component.nonRecurringCost) {
                rec += component.recurringCost;
                now += component.nonRecurringCost;
                if (component.depositPrice) {
                  now += +component.depositPrice;
                }
                if (component.usageCharge) {
                  now += +component.usageCharge;
                }
                if (component.setupFee) {
                  now += +component.setupFee;
                }
              } else {
                rec += component.price.recurringPrice
                  ? +component.price.recurringPrice.price
                  : 0;
                now += component.price.recurringPrice
                  ? 0
                  : +component.price.purchasePrice;
                if (component.otherPrices && component.otherPrices.length > 0) {
                  for (var i = 0; i < component.otherPrices.length; i++) {
                    now += +component.otherPrices[i].price;
                  }
                }
              }
            }
          }
        });
      // 	component.customerViewable &&
      // 	(component.quantity && component.quantity > 0
      // 		? ((recCustom += component.price.recurringPrice ? component.price.recurringPrice.price * component.quantity : 0),
      // 			(nowCustom += component.price.recurringPrice ? 0 : component.price.purchasePrice * component.quantity))
      // 		: ((rec += component.price.recurringPrice ? component.price.recurringPrice.price : 0),
      // 			(now += component.price.recurringPrice ? 0 : component.price.purchasePrice)))
      // );

      // recTotal += rec;
      // nowTotal += now;
      // recTotal += recCustom;
      // nowTotal += nowCustom;

      // let recItemPrice = rec;
      // let nowItemPrice = now;

      // tempRecDiscountedPrice += recItemPrice - recItemPrice * (discount / 100);
      // tempNowDiscountedPrice += nowItemPrice - nowItemPrice * (discount / 100);

      // tempRecDiscountedPrice += recCustom - recCustom * (discount / 100);
      // tempNowDiscountedPrice += nowCustom - nowCustom * (discount / 100);
      recTotal += rec * solutions[i].quantity;
      nowTotal += now * solutions[i].quantity;
      recTotal += recCustom * solutions[i].quantity;
      nowTotal += nowCustom * solutions[i].quantity;

      let recItemPrice = rec * solutions[i].quantity;
      let nowItemPrice = now * solutions[i].quantity;

      let recItemPriceCustom = recCustom * solutions[i].quantity;
      let nowItemPriceCustom = nowCustom * solutions[i].quantity;

      tempRecDiscountedPrice += recItemPrice - recItemPrice * (discount / 100);
      tempNowDiscountedPrice += nowItemPrice - nowItemPrice * (discount / 100);

      tempRecDiscountedPrice +=
        recItemPriceCustom - recItemPriceCustom * (discount / 100);
      tempNowDiscountedPrice +=
        nowItemPriceCustom - nowItemPriceCustom * (discount / 100);
    }

    // One time cost
    // nowDiscountedPrice += nowTotal - (nowTotal * (discount / 100))
    // Monthly suscription cost
    // recDiscountedPrice += recTotal - (recTotal * (discount / 100))

    // nowPackagedSolutionTotal = now * solutions[i].quantity
    // recPackagedSolutionTotal = rec * solutions[i].quantity
    // recDiscountedPrice += recPackagedSolutionTotal - (recPackagedSolutionTotal * (discount / 100))
  }
  for (let i = 0; i < accessories.length; i++) {
    if (tenantId) {
      if (accessories[i].tenantId === tenantId) {
        nowTotal += accessories[i].price * accessories[i].quantity;

        let tempAccPrice = accessories[i].price * accessories[i].quantity;
        tempNowDiscountedPrice +=
          tempAccPrice - tempAccPrice * (discount / 100);
      }
    } else {
      nowTotal += accessories[i].price * accessories[i].quantity;

      let tempAccPrice = accessories[i].price * accessories[i].quantity;
      tempNowDiscountedPrice += tempAccPrice - tempAccPrice * (discount / 100);
    }
  }
  nowDiscountedPrice = tempNowDiscountedPrice;
  recDiscountedPrice = tempRecDiscountedPrice;
  if (totalRCDiscount && totalRCDiscount > 0) {
    recTotal = recTotal - totalRCDiscount;
  }
  if (totalNRDiscount && totalNRDiscount > 0) {
    nowTotal = nowTotal - totalNRDiscount;
  }

  return {
    recTotal,
    nowTotal,
    nowDiscountedPrice,
    recDiscountedPrice,
    totalDiscount,
  };
};
